export default __webpack_public_path__ + "static/media/invest_minas-1.e0fd381e.png";